var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_311_442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 8.66667C20 3.8805 27.2757 0 36.25 0C45.2243 0 52.5 3.8805 52.5 8.66667C52.5 13.4528 45.2243 17.3333 36.25 17.3333C27.2757 17.3333 20 13.4528 20 8.66667ZM36.25 21.6667C34.0248 21.6667 31.9145 21.4175 29.9862 20.9842C27.0417 18.7763 22.2165 17.3333 16.75 17.3333C7.77567 17.3333 0.5 21.2138 0.5 26C0.5 30.7862 7.77567 34.6667 16.75 34.6667C25.7243 34.6667 33 30.7862 33 26C33 25.9372 32.9848 25.8765 32.9827 25.8137H33V30.3333C33 35.1195 25.7243 39 16.75 39C7.77567 39 0.5 35.1195 0.5 30.3333V34.6667C0.5 39.4528 7.77567 43.3333 16.75 43.3333C25.7243 43.3333 33 39.4528 33 34.6667V39C33 43.7862 25.7243 47.6667 16.75 47.6667C7.77567 47.6667 0.5 43.7862 0.5 39V43.3333C0.5 48.1195 7.77567 52 16.75 52C25.7243 52 33 48.1195 33 43.3333V43.16C34.0508 43.2727 35.1363 43.3333 36.25 43.3333C45.2243 43.3333 52.5 39.4528 52.5 34.6667V30.3333C52.5 34.9245 45.8007 38.6728 37.3333 38.9718V34.6385C45.8007 34.3395 52.5 30.5933 52.5 26V21.6667C52.5 26.2578 45.8007 30.0062 37.3333 30.3052V25.9718C45.8007 25.6728 52.5 21.9267 52.5 17.3333V13C52.5 17.7862 45.2243 21.6667 36.25 21.6667Z",
    fill: "#660066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5e25349931fcba28ad2193822a5ba2ce.svg";
export { ForwardRef as ReactComponent };